import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';

export const OrganizationPrivilegeIds = {
  settings: 'org:settings',
  members: 'org:members',
  allowlist: 'org:allowlist',
  delete: 'org:delete',
  vaultMove: 'org:vault:move',
} as const;

const OrganizationPrivileges: PrivilegeDefinition[] = [
  {
    id: OrganizationPrivilegeIds.settings,
    scope: 'organization',
    feature: 'organizations',
    description: 'Manage organization settings (name, slug).',
  },
  {
    id: OrganizationPrivilegeIds.members,
    scope: 'organization',
    feature: 'organizations',
    description: 'Manage organization-level members.',
  },
  {
    id: OrganizationPrivilegeIds.allowlist,
    scope: 'organization',
    feature: 'organizations',
    description: 'Manage organization domain allowlist.',
  },
  {
    id: OrganizationPrivilegeIds.delete,
    scope: 'organization',
    feature: 'organizations',
    description: 'Delete an organization permanently.',
  },
  {
    id: OrganizationPrivilegeIds.vaultMove,
    scope: 'organization',
    feature: 'organizations',
    description: 'Move vaults into this organization.',
  },
];

export class OrganizationFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'organizations',
    privileges: OrganizationPrivileges,
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return OrganizationFeatureModule.definition;
  }
}
